import _ from "lodash"

import { handleGetTransactionPageGroup, PageId } from "../common/pageId"
import {
  AirportSeasonConfiguration,
  AirportSeasonConfigurations
} from "../api/AirportSeasonConfiguration"

import DropdownButton from "./generic/buttons/DropdownButton"
import { PageGroup } from "../common/transaction"
import RadioControls from "./generic/form/RadioControls"
import Card from "./generic/Card"
import { useEffect } from "react"
import { PageContent } from "../common/pageText"
import { useAppSelector } from "../app/hooks"
import useIsDesktopWidth from "../hooks/useIsDesktopWidth"

export enum ExportFormat {
  CSV = "CSV",
  CSVSemicolon = "CSV (;)",
  PDF = "PDF"
}

export interface IDownloadPaneProps {
  pageId: PageId
  airportSeasons: AirportSeasonConfigurations
  onDownload?: (reportFormat: string) => void
  onExport?: (reportFormat: string) => void
  handleDownloadTypes?: (value: string) => void
  checked?: string
  historyRowAirports?: string[]
}

const DownloadPane: React.FunctionComponent<IDownloadPaneProps> = ({
  pageId,
  airportSeasons,
  onDownload,
  handleDownloadTypes,
  onExport,
  checked,
  historyRowAirports
}) => {
  const { season, airports, countries } =
    useAppSelector(
      (state) => state["selectionReducer"].airportSeasonsSelector
    ) || {}
  const pageGroup = handleGetTransactionPageGroup(pageId)
  const isDownloadPage = pageGroup === PageGroup.DOWNLOAD

  const getConfiguration = (): AirportSeasonConfigurations => {
    const airportSeasonsClone = _.cloneDeep(airportSeasons)

    const configs: AirportSeasonConfigurations = _.filter(
      airportSeasonsClone,
      (rec: AirportSeasonConfiguration) => {
        return (
          (rec.season === season &&
            airports.length > 0 &&
            _.findIndex(
              historyRowAirports ? historyRowAirports : airports,
              (a) => {
                return a === rec.airport
              }
            ) !== -1) ||
          (rec.season === season &&
            airports.length === 0 &&
            countries.length > 0 &&
            _.findIndex(countries, (a) => {
              return a === rec.country
            }) !== -1)
        )
      }
    )
    return configs
  }

  const airportSeasonConfig = getConfiguration()

  const getReportFormats = (): string[] => {
    var airportsreportFormats: string[][] = []
    _.map(airportSeasonConfig, (rec) => {
      if (rec.supportsDownload === true) {
        airportsreportFormats.push(rec.reportFormats)
      }
    })

    var intersection: string[] = _.intersection.apply(_, airportsreportFormats)

    var reportFormatsOpt = _.map(intersection, (o) => {
      return o
    })
    return reportFormatsOpt
  }

  const reportFormats = getReportFormats()

  useEffect(() => {
    if (
      (checked === "" ||
        checked === null ||
        !reportFormats.includes(checked)) &&
      handleDownloadTypes
    ) {
      handleDownloadTypes(reportFormats.length ? reportFormats[0] : null)
    }
    // eslint-disable-next-line
  }, [reportFormats])

  const handleSubmitExport = (exportFormat: string) => {
    if (typeof onExport === "function") {
      onExport(exportFormat)
    }
  }
  const isDesktopWidth = useIsDesktopWidth()
  const handleGetColumnCount = (): number => {
    const reportsLength = reportFormats.length
    let columnCount = isDesktopWidth ? 3 : 2
    if (reportsLength <= 6) {
      columnCount = 1
    }
    if (reportsLength > 6 && reportsLength <= 21) {
      columnCount = 2
    }
    if (reportsLength > 21) {
      if (isDesktopWidth) {
        columnCount = 3
      } else {
        columnCount = 2
      }
    }

    return columnCount
  }

  // const getDownloadHidden = (): boolean => {
  //   var downloadHidden = false
  //   _.map(airportSeasonConfig, (rec) => {
  //     if (rec.downloadHidden === true) {
  //       downloadHidden = true
  //       return
  //     }
  //   })
  //   return downloadHidden
  // }

  const hiddenFunc = (key: string) => {
    const airportSeasonConfigArr = airportSeasonConfig.filter(
      (a) => a[key] === true
    )

    return airportSeasonConfigArr.length > 0
  }

  const downloadHidden = hiddenFunc("downloadHidden")
  const exportHidden = hiddenFunc("exportHidden")

  //const downloadHidden = airportSeasonConfig ? getDownloadHidden() : false

  return isDownloadPage ? (
    <Card title="Format">
      <div className="ocs-field-container ocs-mb-16 ocs-mt-8">
        {reportFormats.length > 0 ? (
          <ul
            style={{
              gridTemplateRows: _.repeat(
                "auto ",
                Math.ceil(reportFormats.length / 3)
              )
            }}
            className="radio-list"
          >
            {reportFormats.map((value, idx) => {
              return (
                <li key={idx} className="radio-field">
                  <RadioControls
                    onChange={() => handleDownloadTypes(value)}
                    checked={checked === value}
                    inputIdentifier={value}
                    label={value}
                    name={value}
                    value={value}
                    className="ocs-radio-container d-flex align-items-center"
                  />
                </li>
              )
            })}
          </ul>
        ) : (
          <p className="ocs-mt-8 ocs-mb-16">
            {airports.length <= 0
              ? "Please select an airport to see available download formats"
              : airports.length === 1
              ? "The chosen airport has no available download formats"
              : "One of the chosen airports has no available download formats"}
          </p>
        )}
      </div>
    </Card>
  ) : (
    (!downloadHidden || !exportHidden) && (
      <DropdownButton
        disabled={pageId === PageId.ViewFlightsEUACA}
        radioLinks={[
          {
            groupTitle: PageContent.download,
            subtitle: "- from coordinators",
            radioValues: reportFormats,
            columns: handleGetColumnCount(),
            onSubmit: onDownload,
            hidden: downloadHidden
          },
          {
            groupTitle: PageContent.export,
            subtitle: "- from screen",
            radioValues: [
              ExportFormat.CSV,
              ExportFormat.CSVSemicolon,
              ExportFormat.PDF
            ],
            columns: 1,
            onSubmit: handleSubmitExport,
            hidden: exportHidden
          }
        ]}
        className="download-btn"
      >
        {PageContent.download}
      </DropdownButton>
    )
  )
}
export default DownloadPane
